import React from 'react';
import ReactDOM from 'react-dom';
import Dict from 'dict-lib';
import LexemePage, {getPage, LexemePageContent} from './page/LexemePage';
import {
    LanguageTypeAheadTypes,
    LexemeDisplayContext,
    LexemeEditingLevel,
    LexemeUtilities
} from './page/editor/LexemeHelper';
import {Modal, Button, Col, Row, InputGroup, FormControl} from 'react-bootstrap';
import {EntryExternalDictionary} from "./page/editor/entry/EntryExternalDictionary";
import stylesSearchMenu from './../_css/dictionary/searchMenu.module.css';
import stylesLexemeTitle from "../_css/dictionary/lexemeParts/lexemeTitle.module.css";
import {LexemeTitle} from "./page/parts/01_Title/LexemeTitle";
import {LexemaPageContextProvider} from "./page/LexemePageContextProvider";
import Platform from "react-native-web/dist/apis/Platform";

export class RenderedPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            page: 'Caricamento...'
        };
    }

    componentDidMount() {
        //LexemeUtilities.openLexemePage(result.id, result.rootEntryId, true, LexemeEditingLevel.READ_ONLY, result.entryForm, undefined, result.entryAbstr, result.language, result.languageCode);
        const useTabs = false;
        /*console.log(Platform.OS);*/
        /*var apiHost = window.location.hostname === 'localhost'
            ? 'http://localhost:9090'
            : `http://${window.location.hostname}:9090`;*/

        Dict.call('/page/getPage/' + this.props.match.params.id + '/' + null + '/' + null/*, undefined, apiHost*/).then(result => {
            if(useTabs || true) {
                LexemeUtilities.openLexemePage(this.props.match.params.id, this.props.match.params.id, true, LexemeEditingLevel.READ_ONLY, result.page.title.entry_form, undefined, result.entryAbstr, result.language, result.page.dictionary_properties.language_code, LexemeDisplayContext.SINGLE_PAGE);
            } else {
                const LexemePageConst = <LexemaPageContextProvider idPostFix={'app'}
                                                                   classType={'ENTRIES'}
                                                                   pageStatus={LexemeEditingLevel.READ_ONLY}
                                                                   page={result.page}
                                                                   displayContext={LexemeDisplayContext.SINGLE_PAGE}
                                                                   descrLanguage={result.descrLanguage}
                                                                   sharedOptions={result.sharedOptions}
                />;
                setTimeout(() => {
                    this.setState({page: LexemePageConst});
                }, 1000);
                //ReactDOM.render(LexemePageConst, document.getElementById('lexeme-page-container'));
            }
        });
    }


    /*emptyModalContainer() {
        setTimeout(function () {
            ReactDOM.unmountComponentAtNode(document.getElementById('dict-modal-external-entry-container'));
        }, 500);
    }*/

    render() {
        return <div id={'lexeme-page-container'}>{this.state.page}</div>
    }
}